import { Record } from 'immutable';
export function combineReducersMap(reducers, initialState) {
  var reducersRecord = Record(reducers)().toSeq();
  return function (inputState, action) {
    return inputState.withMutations(function (temporaryState) {
      reducersRecord.forEach(function (reducer, reducerName) {
        var currentDomainState = temporaryState.get(reducerName);
        var nextDomainState = reducer(currentDomainState, action);
        temporaryState.set(reducerName, nextDomainState);
      });
    });
  };
}